import React from 'react';
import { palette } from 'src/styles/colors';

interface SVGIconProps {
  width?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
}

const PaperPlane = ({ width, fill = palette.white, stroke = fill, strokeWidth = 2 }: SVGIconProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '20'}
      viewBox='0 0 33 34'
      fill='none'
    >
      <path
        d='M25.2919 30.8257L18.1669 27.8257L15.7919 31.9507C15.3544 32.7632 14.4169 33.1382 13.5419 32.8882C12.6669 32.7007 12.1044 31.8882 12.1044 30.9507V25.3257L1.29187 20.8257C0.604366 20.5132 0.104366 19.8882 0.104366 19.0757C0.0418663 18.3257 0.416866 17.6382 1.10437 17.2632L1.60437 18.1382C1.22937 18.3257 1.04187 18.6382 1.10437 19.0132C1.10437 19.4507 1.35437 19.7632 1.66687 19.8882L12.2294 24.3257L30.0419 1.95068C29.9169 2.01318 29.7294 2.01318 29.6044 2.13818L1.60437 18.1382L1.10437 17.2632L29.1044 1.26318C29.6044 0.950684 30.2294 0.888184 30.7294 1.07568C30.9169 1.13818 31.0419 1.26318 31.2294 1.32568C31.2919 1.38818 31.3544 1.45068 31.4169 1.51318C31.4794 1.57568 31.5419 1.57568 31.6044 1.63818C31.9794 2.07568 32.1669 2.70068 32.0419 3.26318L28.0419 29.2632C27.9794 29.8882 27.6044 30.3882 27.0419 30.7007C26.5419 31.0132 25.8544 31.0757 25.2919 30.8257ZM13.2294 24.7007L18.5419 26.9507L25.6669 29.8882C25.9794 30.0132 26.2919 30.0132 26.5419 29.8257C26.8544 29.7007 27.0419 29.4507 27.0419 29.1382L31.0419 3.13818C31.1044 2.88818 31.0419 2.63818 30.9169 2.45068L13.2294 24.7007ZM13.1044 25.7007V30.9507C13.1044 31.4507 13.3544 31.8257 13.7919 31.9507C14.2294 32.0757 14.7294 31.8882 14.9169 31.4507L17.2294 27.4507L13.1044 25.7007Z'
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default PaperPlane;
